import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import ManageRolesPage from './index';

const ManageRoles = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb homePath={'/dashboard'} routeSegments={[{ name: 'Quản lý vai trò' }]} />
      </div>
      <ManageRolesPage />
    </ContainerBody>
  );
};

export default compose(withPaginate)(ManageRoles);
